module.exports = __webpack_public_path__ + "img/partnerschaft.6a5ff4fc.svg";